import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'span[app-card-indicators-icon]',
  standalone: true,
  template: '<ng-content></ng-content>',
  styleUrls: ['card-indicators-icon.component.scss'],
})
export class CardIndicatorsIconComponent {
  @HostBinding('class.card-indicators-icon') readonly isCardIndicatorsIcon = true;
}
